import { Injectable } from '@angular/core';

import { AttendanceFormComponent } from './attendance-form.component';
import { unsaveConfirm } from '../app.const';

@Injectable({
  providedIn: 'root'
})
export class AttendanceFormCanDeactivateGuard  {
  canDeactivate(component: AttendanceFormComponent): boolean {
    if (component.pageData.isUnsaved) {
      if (unsaveConfirm()) {
        return true;
      } else {
        return false;
      }
    }
    return true;

  }
}
